import { render, staticRenderFns } from "./PurchaseOrderItemsQuantitiesOrderTable.vue?vue&type=template&id=89ad146c&scoped=true"
import script from "./PurchaseOrderItemsQuantitiesOrderTable.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderItemsQuantitiesOrderTable.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderItemsQuantitiesOrderTable.vue?vue&type=style&index=0&id=89ad146c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ad146c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89ad146c')) {
      api.createRecord('89ad146c', component.options)
    } else {
      api.reload('89ad146c', component.options)
    }
    module.hot.accept("./PurchaseOrderItemsQuantitiesOrderTable.vue?vue&type=template&id=89ad146c&scoped=true", function () {
      api.rerender('89ad146c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/purchase-orders/PurchaseOrderItemsQuantitiesOrderTable.vue"
export default component.exports